import React, { useEffect, useState } from 'react';
import { ProfileTriggerContent } from './components/ProfileTriggerContent';
import { BlockListWrapper } from './components/BlockListWrapper';
import { eventBus } from '../../services/eventBus';

interface ICustomerProfileProps {
  isHidden?: boolean;
}

export const CustomerProfile = (props: ICustomerProfileProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState<boolean>(false);

  useEffect(() => {
    window.addEventListener('mousedown', (e: any) => {
      if (
        !document.getElementById('profileToggleContent')?.contains(e.target) &&
        !document.getElementById('profileTrigger')?.contains(e.target) &&
        !document.getElementById('PlanUpgradeFlow')?.contains(e.target) &&
        !document.getElementById('cancelConfirmationModal')?.contains(e.target) &&
        !document.getElementById('planErrorModal')?.contains(e.target) &&
        !document.getElementById('AccountDetailsModal')?.contains(e.target) &&
        !document.getElementById('AccountSwitcherWrapper')?.contains(e.target)
      ) {
        setIsMenuOpen(false);
      }
    });
    eventBus.on('closeProfileMenu', () => setIsMenuOpen(false));
  }, []);

  return (
    <div
      className={` absolute ${props?.isHidden ? 'invisible' : ''} right-[32px] top-[32px] z-[100] duration-150 max-w-[317px] w-[317px]`}
    >
      <button
        type='button'
        onClick={() => setIsMenuOpen(!isMenuOpen)}
        className='bg-surface-primary-bw-00 cursor-pointer hover:bg-bw01 h-[60px] pl-[14px] pr-[50px] bg-bw00 shadow-light rounded-[8px] w-full'
        id='profileTrigger'
      >
        <ProfileTriggerContent isMenuOpen={isMenuOpen} />
      </button>
      {isMenuOpen && <BlockListWrapper />}
    </div>
  );
};
